// session/useUserSession.js

import { useContext } from "react";
import { UserSessionContext } from "./UserSessionContext";

export function useUserSession() {
  return useContext(UserSessionContext);
}